var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tabs"},[_c('v-tabs',_vm._b({attrs:{"value":_vm.value},on:{"input":_vm.update,"change":_vm.changed}},'v-tabs',_vm.$props,false),[_c('v-tabs-slider'),_vm._t("tabs-headers")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }